<template>
    <div>
        <report-header
            :title="title"
            :isShowDateRange="isShowDateRange"
            :formatDateRangeTitle="dateRange"
        />
        <b-card id="report-card">
            <div class="mb-4">
                <div id="report-body" class="w-100">
                    <QTable
                        :columns="columns"
                        :data="detail"
                        hide-bottom
                        :loading="loaded"
                        class="mb-4"
                        :rows-per-page-options="[0]"
                    >
                        <template
                            v-slot:bottom-row
                            v-if="detail.length === 0 && !loaded"
                        >
                            <q-tr>
                                <q-td colspan="10" align="center">
                                    {{
                                        isShowDateRange
                                            ? "No records available"
                                            : "Please select the filter"
                                    }}.
                                </q-td>
                            </q-tr>
                        </template>
                    </QTable>
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>
import ScheduleHelper from "@/module/schedule/helper";
import Report from "@/mixins/report.js";
import { QTable } from "quasar";
import { isEmpty, forEach } from "lodash";
import ClientServices from "@/services/client";
import PatientServices from "@/services/patient";
import ReportService from "@/services/report";
import CREPORT from "@/constants/report";
export default {
    mixins: [ScheduleHelper, Report],
    components: {
        QTable,
        ReportHeader: () => import("@/components/report/report-header")
    },
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: this.getStartDate("month"),
                    end: this.getEndDate("day"),
                    datePickerOptions: {
                        format: this.getDateFormat()
                    },
                    clientIds: {
                        type: []
                    },
                    patientIds: {
                        type: []
                    }
                };
            }
        }
    },
    data() {
        return {
            locale: "en-US",
            loaded: false,
            summary: [],
            detail: [],
            refresh: 0,
            title: "Appointment Log",
            meta: "",
            isShowDateRange: false,
            columns: [
                {
                    name: "apptDateTime",
                    field: "appt_start",
                    label: "Appt Date / Time",
                    align: "left",
                    headerStyle: "width:10%"
                },
                {
                    name: "initialApptDateTime",
                    field: "init_appt_start",
                    label: "Initial Appt Date / Time",
                    align: "left",
                    headerStyle: "width:10%"
                },
                {
                    name: "initialType",
                    field: "initApptType",
                    label: "Initial Type",
                    align: "left",
                    headerStyle: "width:10%"
                },
                {
                    name: "updatedType",
                    field: "updatedApptType",
                    label: "Updated Type",
                    align: "left",
                    headerStyle: "width:10%"
                },
                {
                    name: "initialPatient",
                    field: "initPatientName",
                    label: "Initial Patient",
                    align: "left",
                    headerStyle: "width:10%"
                },
                {
                    name: "updatedPatient",
                    field: "updatedPatientName",
                    label: "Updated Patient",
                    align: "left",
                    headerStyle: "width:10%"
                },
                {
                    name: "initialClient",
                    field: "initClientName",
                    label: "Initial Client",
                    align: "left",
                    headerStyle: "width:10%"
                },
                {
                    name: "updatedClient",
                    field: "updatedClientName",
                    label: "Updated Client",
                    align: "left",
                    headerStyle: "width:10%"
                },
                {
                    name: "updatedAt",
                    field: "create_at",
                    label: "Updated At",
                    align: "left",
                    headerStyle: "width:10%"
                },
                {
                    name: "updatedBy",
                    field: "logCreatedBy",
                    label: "Updated By",
                    align: "left",
                    headerStyle: "width:10%"
                }
            ],
            dateRange: ""
        };
    },

    mounted() {
        let self = this;
        self.data.isShowDateRange = true;
        self.data.start = self.getStartDate("month");
        self.data.end = self.getEndDate("day");
        self.data.from = self.converToUnix(self.data.start);
        self.data.to = self.converToUnix(self.data.end);
        self.data.datePickerOptions.format = this.getDateFormat();
        self.data.datePickerOptionDefault = 3;
        self.data.filterDateOption = true;
        let query = self.$route.query;
        if (!isEmpty(query.to) && !isEmpty(query.from)) {
            self._getSetting().then(() => {
                self.initSetDates().then(() => {
                    self.init();
                });
            });
        }
        self.$root.$on("report-filter-date-range:refresh", self.filterReport);

        self.$root.$on("appointment-log:refresh", function () {
            self.refresh = 1;
            self.init();
        });
        window.scrollTo(0, 0);
    },
    beforeDestroy: function () {
        this.$root.$off("report-filter-date-range:refresh", this.filterReport);
        // Will turn off the listener globally // used only here
        this.$root.$off("appointment-log:refresh");
    },
    computed: {
        formatDateRangeTitle() {
            if (this.data.start && this.data.end) {
                return `(${this.data.start.format(
                    this.getDateFormat()
                )} - ${this.data.end.format(this.getDateFormat())})`;
            }

            return null;
        }
    },
    methods: {
        filterReport(params) {
            this.refresh = 0;
            this.init(params);
        },
        async initSetDates() {
            let query = this.$route.query;
            let self = this;
            if (!isEmpty(query.to) && !isEmpty(query.from)) {
                this.data.datePickerOptionDefault = 1;
                this.data.start = moment.unix(query.from).tz(this._timeZone);
                this.data.end = moment.unix(query.to).tz(this._timeZone);
                this.data.from = query.from;
                this.data.to = query.to;
                this.dateRange = this.getDateRange(query.from, query.to);
                if (!isEmpty(query.clientIds)) {
                    const clientIds = [];
                    forEach(JSON.parse(query.clientIds), async function (
                        clientId
                    ) {
                        clientIds.push(clientId);
                        await self.fetchClient(clientId);
                    });
                    this.data.clientIds = clientIds;
                }
                if (!isEmpty(query.patientIds)) {
                    const patientIds = [];
                    forEach(JSON.parse(query.patientIds), async function (
                        patientId
                    ) {
                        patientIds.push(patientId);
                        await self.fetchPatient(patientId);
                    });
                    this.data.patientIds = patientIds;
                }
            } else {
                this.data.start = this.getStartDate("isoWeek");
                this.data.end = this.getEndDate("day");
                this.data.from = this.converToUnix(this.data.start);
                this.data.to = this.converToUnix(this.data.end);
            }
        },
        async init(params) {
            let self = this;
            self.isShowDateRange = true;
            self.loaded = true;
            let reportParams = {
                clientIds: params ? params.clientIds : self.data.clientIds,
                patientIds: params ? params.patientIds : self.data.patientIds,
                refresh: self.refresh
            };
            if (params) {
                reportParams.from = params.from;
                reportParams.to = params.to;
                this.dateRange = this.getDateRange(
                    reportParams.from,
                    reportParams.to
                );
            } else {
                (reportParams.from = this.data.from),
                    (reportParams.to = this.data.to);
            }
            await ReportService.getReport(
                CREPORT.TYPE.APPOINTMENT_LOG,
                reportParams
            )
                .then(response => {
                    if (
                        response &&
                        response.message &&
                        response.message.code === 200
                    ) {
                        self.loaded = false;
                        self.code = response.status;
                        self.meta = response.resource.meta;
                        self.detail = response.resource.results;
                        self.title = self.capitalize(self.meta.title);
                    } else if (response.queue) {
                        self._message(response.message, "warning");
                    }
                })
                .catch(e => {
                    console.error(e);
                    self._message("Error: Unable to get the report.", "danger");
                    self.loaded = true;
                })
                .finally(() => {
                    self.loaded = false;
                });
        },
        async fetchClient(clientId) {
            const response = await ClientServices.getClient(clientId);
            if (response) {
                let client = response.resource;
                let fullName = `${client.firstname} ${client.lastname}`;
                this.data.client = {
                    ...response.resource,
                    fullName: fullName,
                    label: fullName
                };
            }
        },
        async fetchPatient(patientId) {
            const response = await PatientServices.getDetails(patientId);
            if (response?.resources) {
                this.data.patient = response.resources;
            }
        }
    }
};
</script>
